import React from "react";
import { Link } from "react-router-dom";
import styles from "./NotFound.module.css";

const NotFound = (): JSX.Element => {
  return (
    <div className="container">
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.textContainer}>
            <h1 className={styles.title}>404</h1>
            <p className={styles.description}>
              ¡Oh no! Parece que el confetti ha bloqueado el camino hacia esta
              página. Pero no te preocupes, estamos barriendo el exceso de
              diversión para que puedas seguir explorando nuestra colección de
              productos y servicios para fiestas. ¡No te quedes atrás!
            </p>
            <div className={styles.buttonContainer}>
              <Link to="/" className={`buttonMain ${styles.button}`}>
                Volver al Home
              </Link>
            </div>
          </div>
          <div className={styles.imageContainer}>
            <div className={styles.imageWrapper}>
              <img
                src={`${process.env.REACT_APP_IMAGE_FOLDER}/404_icon_33772fb7ba.svg`}
                alt="404"
                className={styles.image}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
